import styled from "styled-components";

import { setFontVariant, colorsPalettes } from "@similarweb/styles";

import { translate } from "app/filters/i18nFilter";
import { minVisitsAbbrFilter } from "app/filters/ngFilters";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { Keyword } from "../types";

import { Checkbox } from "./Checkbox";

const { carbon } = colorsPalettes;

const Bold = styled.div`
    ${setFontVariant("subtitle2", carbon["400"])};
`;
const ContentContainer = styled.div<{ selected: boolean }>`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 2px 48px 2px 12px;
`;

const Delimiter = styled.div`
    height: 1px;
    background-color: ${carbon[100]};
    box-sizing: border-box;
    padding: 0;
    margin: 4px 48px 0 48px;
`;

const TotalMatchingKeywordsContainer = styled(FlexColumn)`
    gap: 8px;
    cursor: pointer;
`;

const formatVolume = (value: number): string | number => {
    return minVisitsAbbrFilter()(value, 0);
};

interface TotalMatchingKeywordsProps {
    keywords: Keyword[];
    onClick: VoidFunction;
    selected: boolean;
    semiSelected: boolean;
}

export const TotalMatchingKeywords = ({ keywords, onClick, selected, semiSelected }: TotalMatchingKeywordsProps) => {
    const count = keywords.length;

    if (count < 2) {
        return null;
    }

    const totalVolume = keywords.reduce((acc, { volume = 0 }) => acc + volume, 0);
    const formattedTotalVolume = formatVolume(totalVolume);

    return (
        <TotalMatchingKeywordsContainer onClick={onClick}>
            <ContentContainer selected={selected}>
                <FlexRow
                    gap="8px"
                    alignItems="center"
                >
                    <Checkbox
                        selected={selected ? !semiSelected : undefined}
                        semiSelected={semiSelected}
                    />
                    <Bold>
                        {translate("auto.keyword.list.generator.body.suggestions.mathching.keywords.total", {
                            count: count,
                        })}
                    </Bold>
                </FlexRow>
                <Bold>{formattedTotalVolume}</Bold>
            </ContentContainer>
            <Delimiter />
        </TotalMatchingKeywordsContainer>
    );
};
